import { render } from "./GoalsIcons.vue?vue&type=template&id=359c7652"
import script from "./GoalsIcons.vue?vue&type=script&lang=js"
export * from "./GoalsIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__